import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { openPunchModal, signoutUser, pollingStart, syncData, startSocketIO } from '../actions';
import ModalPunch from './modal_punch';

class Header extends Component {

  componentDidMount() {
    //if (!this.props.polling.pollingOn) {
    //  this.props.pollingStart();
    //}
    // Connect to API using socket.io (will happen on refresh too)
    this.props.startSocketIO();
  }

  handleSignout = () => {
    this.props.signoutUser();
  }

  renderUsername = () => {
    if (this.props.restaurant.currentUser.firstname) {
      return this.props.restaurant.currentUser.firstname
    } else {
      return "Undefined";
    }
  }

  render() {
    return(
      <div className="site-header">
  			<nav className="navbar navbar-light">
  				<div className="navbar-left">
  					<Link className="navbar-brand" to="/dashboard">
  						<div className="logo"></div>
  					</Link>
  					<div className="toggle-button dark sidebar-toggle-first float-xs-left hidden-md-up">
  						<span className="hamburger"></span>
  					</div>
  					<div className="toggle-button dark float-xs-right hidden-md-up" data-toggle="collapse" data-target="#collapse-1">
  						<span className="more"></span>
  					</div>
  				</div>
  				<div className="navbar-right navbar-toggleable-sm collapse" id="collapse-1">
  					<div className="toggle-button light sidebar-toggle-second float-xs-left hidden-sm-down">
  						<span className="hamburger"></span>
  					</div>
            <div>
              <ul className="nav navbar-nav">
                <li className="nav-item">
                  <span>Liberty Noodle</span>
                </li>
              </ul>
            </div>
            <div className="float-md-right pr-1">
              <ul className="nav navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href="#openpunch" onClick={event => this.props.openPunchModal()}>
                    Punch In
                  </a>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#username" data-toggle="dropdown" aria-expanded="false">
                    {this.renderUsername()}
                  </a>
                  <div className="dropdown-menu animated flipInY">
                    <a className="dropdown-item" href="#settings">
                      Settings
                    </a>
                    <div className="dropdown-divider"></div>
                    <a onClick={this.handleSignout} className="dropdown-item" href="#signout">Sign Out</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <ModalPunch />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    restaurant: state.restaurant,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { openPunchModal, signoutUser, pollingStart, syncData, startSocketIO }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/header.js